import React, { useState } from "react";
import {
  Box,
  Button,
  Chip,
  Stack,
  Typography,
  IconButton,
  Tooltip,
  Menu,
  MenuItem,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import AnalyticsOutlinedIcon from "@mui/icons-material/AnalyticsOutlined";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import { formatDate } from "../format";
import CreditCardOutlinedIcon from "@mui/icons-material/CreditCardOutlined";

const CustomerHeader = ({
  user,
  wallet,
  onBack,
  onClarity,
  onAssignCredits,
  onDeductCredits,
}) => {
  const [menuAnchor, setMenuAnchor] = useState(null);

  const closeMenu = () => setMenuAnchor(null);

  return (
    <Box sx={{ mb: 2.5 }}>
      <Button
        startIcon={<ArrowBackIcon />}
        onClick={onBack}
        sx={{
          textTransform: "none",
          color: "#6b7280",
          mb: 1.5,
          px: 0,
          minWidth: 0,
        }}
      >
        Customers
      </Button>
      <Stack
        direction={{ xs: "column", sm: "row" }}
        justifyContent="space-between"
        gap={1.5}
      >
        <Box>
          <Typography
            sx={{ fontSize: "1.25rem", fontWeight: 600, color: "#111827" }}
          >
            {user?.username || "—"}
          </Typography>
          <Typography sx={{ color: "#6b7280", fontSize: "0.875rem" }}>
            {user?.email}
          </Typography>
          <Typography sx={{ color: "#6b7280", fontSize: "0.8125rem", mt: 0.5 }}>
            Joined {formatDate(user?.createdAt)}
          </Typography>
        </Box>
        <Stack direction="row" spacing={1} alignItems="center">
          <Chip
            label={`${wallet?.remaining_credits ?? 0} credits left`}
            size="small"
            sx={{ bgcolor: "#eff6ff", color: "#1d4ed8", fontWeight: 600 }}
          />

          <Tooltip title="Customer actions">
            <IconButton onClick={(e) => setMenuAnchor(e.currentTarget)}>
              <MoreHorizIcon />
            </IconButton>
          </Tooltip>
          <Menu
            anchorEl={menuAnchor}
            open={Boolean(menuAnchor)}
            onClose={closeMenu}
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            transformOrigin={{ vertical: "top", horizontal: "right" }}
          >
            <MenuItem
              onClick={() => {
                closeMenu();
                onClarity();
              }}
              sx={{ display: "flex", alignItems: "center", gap: 1 }}
            >
              <AnalyticsOutlinedIcon fontSize="small" color="primary" />
              View in Clarity
            </MenuItem>
            <MenuItem
              onClick={() => {
                closeMenu();
                onAssignCredits();
              }}
              sx={{ display: "flex", alignItems: "center", gap: 1 }}
            >
              <CreditCardOutlinedIcon fontSize="small" color="success" />
              Assign credits
            </MenuItem>
            <MenuItem
              onClick={() => {
                closeMenu();
                onDeductCredits();
              }}
              disabled={(wallet?.remaining_credits ?? 0) <= 0}
              sx={{ display: "flex", alignItems: "center", gap: 1 }}
            >
              <CreditCardOutlinedIcon fontSize="small" color="error" />
              Deduct credits
            </MenuItem>
          </Menu>
        </Stack>
      </Stack>
    </Box>
  );
};

export default CustomerHeader;
